/* eslint-disable react/display-name */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react';
import { useTranslation } from 'react-i18next';

import useReportQueryParams from 'components/ReportsModule/hooks/use-report-query-params';
import ScheduledActivityChart from '../../charts/ScheduledActivityChart';
import ReportCard from 'components/ReportsModule/components/common/ReportCard';
import { KeyClassroomEngagementStudentResult } from 'types/schema-generated-types';
import { ReportEntityType } from 'components/ReportsModule/types';

const ClassroomScheduledActivityChartCard: React.FC<{
  reportData: KeyClassroomEngagementStudentResult[];
  loading: boolean;
}> = ({ reportData = [], loading }) => {
  const { t } = useTranslation(['Reports', 'ReportsHelpCharts']);
  const [, setQuery] = useReportQueryParams();

  const { studentNames, ids, assessmentWpmSeries, assessmentAccuracySeries } = reportData.reduce(
    (acc, { student, scheduledActivities }) => {
      if (!student) return acc;
      const { studentNames, ...stats } = acc;

      studentNames.push(`${student.firstName} ${student.lastName}`);
      stats.ids.push(student.id);
      stats.assessmentWpmSeries.push(scheduledActivities?.assessmentAverageWpm ?? 0);
      stats.assessmentAccuracySeries.push(scheduledActivities?.assessmentAverageAccuracy ?? 0);

      return acc;
    },
    {
      ids: [] as number[],
      studentNames: [] as string[],
      assessmentWpmSeries: [] as number[],
      assessmentAccuracySeries: [] as number[]
    }
  );

  const handleChartClick = (index: number) => {
    setQuery({ entityType: ReportEntityType.STUDENT, entityId: ids[index] }, 'pushIn');
  };

  return (
    <ReportCard
      title={t('Teacher Assigned Assessments')}
      helpText={t('assessments', { ns: 'ReportsHelpCharts' })}
      loading={loading}
      reportData={reportData}
      reportDataProp="scheduledActivities"
    >
      <ScheduledActivityChart
        assessmentWpmSeries={assessmentWpmSeries}
        assessmentAccuracySeries={assessmentAccuracySeries}
        labels={studentNames}
        onClick={handleChartClick}
      />
    </ReportCard>
  );
};

export default ClassroomScheduledActivityChartCard;
